import { IApplicationState } from '../../types/redux';

export const selectIsMotivationPopupVisible = (state: IApplicationState): boolean => {
  return state.favorite.isMotivationPopupVisible;
};
